export const getPopupVisibility = state => state.popup.isExpanded;

export const getPopupSettings = state => state.popup.settings;
